import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-flow-card',
  templateUrl: './flow-card.component.html',
  styleUrls: ['./flow-card.component.scss']
})
export class FlowCardComponent implements OnInit {
  @Input() background = '';
  @Input() border = '';
  @Input() minheight = '';
  @Input() width = '';
  constructor() { }

  ngOnInit(): void {
  }

}
